const v0 = require('./doubleclick.v0');
const v1 = require('./doubleclick.v1');
const {
  setShellEventOrRun,
} = require('src/frontend/helper/general/setShellEvent');

function v1Meta() {
  return !!document.head.querySelector("meta[name='ai-v1']");
}

function guardedInit() {
  const ver = getDoubleClickVer();
  if (ver === 'v1') {
    v1.init();
  } else {
    v0.init();
  }
}
function init() {
  setShellEventOrRun(
    'ls-doubleclick',
    guardedInit,
    () => !(v1Meta() || !!document.head.querySelector("meta[name^='dfp-']"))
  );
}

function getDoubleClickVer() {
  if (Groupon.DFPAds.aiVer != null) {
    return Groupon.DFPAds.aiVer;
  }
  let ver = 'v0';
  if (v1Meta()) {
    ver = 'v1';
  }
  Groupon.DFPAds.aiVer = ver;
  return ver;
}

function isValidConsentCookie() {
  const c3s = window.Cookie.get('c3s');
  if (!c3s) {
    return true;
  }
  //only return false if regexp /^\d+-\d+-([0-1])$/g is matched, example 123423-2342342-(0|1)
  return c3s.match(/^\d+-\d+-([0-1])$/g) === null;
}

function load() {
  const ver = getDoubleClickVer();
  if (ver === 'v1') {
    v1.load();
  } else {
    v0.load();
  }
}

// Groupon.DFPAds:
module.exports = Groupon.DFPAds = {
  init,
  isValidConsentCookie,
  load,
};
